import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Progress } from "./Progress";
import Styles from "./Upload.module.scss";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { UiActions } from "state/actions/UiActions";
import { connect } from "react-redux";

export class Delete extends Component {

  constructor(props){
    super(props);

    this.state = {
      files: this.props.files,
      progress: {},
      deleting: false,
      successful: false,
      response: []
    };
  }  

  clearState = () => {
    this.setState({
      files: [],
      progress: {},
      deleting: false,
      successful: false,
      response: []
    });
  };

  deleteFile = (file) => {
    return async (event) => {
      event.preventDefault();

      this.setState({
        progress: {},
        deleting: true
      });

      const promises = [];

      promises.push(this.deleteRequest(file));

      try {
        const response = await Promise.all(promises);

        const _response = response.filter((item)=>{
          return !item.status && !item.statusCode;
        });
  
        if(_response.length < 1){
          throw new Error("");
        } 

        this.props.publishSuccessAlert("Arquivo apagado com sucesso");

        this.setState({
          successful: true,
          deleting: false,
          response: response,
        }, ()=>{
          if(this.props.onDeleteFinish){
            this.props.onDeleteFinish(file);
            this.clearState();
          }
        });
        return;
      } catch (e) {
        this.props.publishErrorAlert("Erro ao apagar o arquivo");

        this.setState({
          successful: false,
          deleting: false
        });
      }
    };
  };

  /**
   * @param {File} file
   */
  deleteRequest = async (file) => {
    const {
      deleteUrl,
      headers,
      fields
    } = this.props;

    let requestBody = null;
    if(file.fileName){
      requestBody= {
        fileName: file.fileName
      }
    }
  
    requestBody = Object.assign({}, fields, requestBody);  

    return new Promise((resolve, reject) => {
      ExecuteRequest(
        deleteUrl,
        requestBody,
        "POST",
        headers,
        null,
        (response) => {
          const {
            statusCode,
            result
          } = response;

          if (statusCode === 200) {
            let newFiles = this.state.files;

            newFiles = newFiles.filter((item) => {
              return item != file;
            })

            this.setState({
              files: newFiles
            });
            resolve(result);
          } else {
            reject(result);
          }
        }
      );
    })


  };

  renderActions = (file) => {
    const {
      deleteButtonText
    } = this.props;

    const {
      files,
      deleting,
      successful
    } = this.state;

    return (
      <div className={Styles["uploaded"]}>
        <button
          disabled={files.length < 0 || deleting}
          onClick={this.deleteFile(file)}>
          {deleteButtonText}
        </button>
      </div>
    );
  };

  /**
   * @param {File} file
   */
  renderProgress = (file) => {
    const deleteProgress = this.state.progress[file.fileName];
    if (this.state.deleting || this.state.successful) {
      return (
        <Progress
          progress={deleteProgress ? deleteProgress.percentage : 0} />
      );
    }
  };

  render() {
    
    
    return (
      <div
        id={this.props.id}
        className={classnames(this.props.className)}>
        <div className={classnames(this.props.fileListClass)}>
          {this.state.files.map((file, key) => {
            return (
              <div key={key}>               
                {this.renderActions(file)}
                {this.renderProgress(file)}
              </div>
            );
          })}

        </div>
      </div>
    );
  }
}

Delete.defaultProps = {
  headers: {},
  fields: {},
  deleteButtonText: "Remover",
  onDeleteFinish: null,
  className: Styles["upload"]
};

Delete.propTypes = {
  deleteUrl: PropTypes.object.isRequired,
  headers: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ])
  ),
  fields: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool
    ])
  ),
  deleteButtonText: PropTypes.string,
  onDeleteFinish: PropTypes.func,
  // multiple: PropTypes.bool,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.objectOf(PropTypes.bool)
  ])
};

const mapStateToProps = (state) => ({
  store: state,
  token: state.token.data.Authorization
});

const mapDispatchToProps = (dispatch) => ({
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
});

Delete = connect(
  mapStateToProps,
  mapDispatchToProps
)(Delete);
